import React from 'react';
import { IRootStore } from './types';



let rootStore: IRootStore;
let storesContext: React.Context<IRootStore>;

export function setRootStore(store: IRootStore): void {
  rootStore = store;

  storesContext = React.createContext(store);
}

export const useStores = (): IRootStore => React.useContext(storesContext);
export const getStores = (): IRootStore => rootStore;

